import React, {FC} from 'react';
import {PageModel} from "../../core/_model";
const API_URL = process.env.REACT_APP_API_URL

type Props = {
    Post: PageModel
}
const PageTitleRow : FC<Props> = ({Post})  => {
    return (
        <>
            <div className="symbol symbol-50px">
            <div className="col fs-2 fw-bold">
                <a target="_blank"  rel="noreferrer"  className="link-primary" href={`${API_URL}/${Post.url}`}>{Post.title}</a>

            </div>
            {/*<span className="badge badge-circle bg-danger">{Post.unReadComments}</span>*/}
        </div>
        </>
    );
};

export default PageTitleRow;